<template>
    <section
        ref="section1"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <header
            class="sticky top-0 z-10 flex max-h-[64px] min-h-[64px] flex-col items-center justify-between border-b bg-white px-4 pb-2 pt-2 lg:max-h-[136px] lg:min-h-[136px] lg:py-6"
        >
            <div
                class="container mx-auto flex h-full w-full justify-between px-0 lg:px-12"
            >
                <div class="lg:flex lg:flex-col lg:gap-8">
                    <a href="/" class="hidden lg:flex">
                        <v-icon icon="n24-beta"></v-icon>
                    </a>
                    <a
                        :href="routes.previousStep ? routes.previousStep : '/'"
                        class="flex cursor-pointer items-center space-x-2 rounded-full px-4 py-3 text-form text-black-78 hover:bg-green-10"
                    >
                        <v-icon icon="back" size="5"></v-icon>
                        <span>Nazaj</span>
                    </a>
                </div>
                <div class="">
                    <a
                        class="flex items-center space-x-2 rounded-full px-4 py-3 text-form text-black-78 hover:bg-green-10"
                        href="/"
                    >
                        <v-icon icon="close" size="5"></v-icon>
                        <span>Zapri</span>
                    </a>
                </div>
            </div>
        </header>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="flex flex-col gap-10 lg:w-full lg:gap-11">
                <figure class="ml-auto mr-auto flex max-w-lg gap-3">
                    <div>
                        <v-icon icon="add-home-work" size="8"></v-icon>
                    </div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Objavite oglas v nekaj prepostih korakih!
                        </div>
                        <div class="text-body-regular text-black-40">
                            Objava oglasa je popolnoma preposta in traja le
                            nekaj minut.
                        </div>
                    </div>
                </figure>
                <figure class="ml-auto mr-auto items-center gap-7 lg:flex">
                    <div class="flex items-center gap-[10px] lg:flex-col">
                        <div
                            class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-green"
                        >
                            <v-icon
                                icon="pin-house-location"
                                class="text-white"
                            ></v-icon>
                        </div>
                        <div class="text-body-medium-button">
                            1. Osnovni podatki
                        </div>
                    </div>
                    <v-icon
                        icon="arrow-right"
                        class="hidden text-gray lg:flex"
                    ></v-icon>
                    <div
                        class="mb-2 mt-2 flex w-[40px] justify-center lg:hidden"
                    >
                        <v-icon icon="arrow-down" class="text-gray"></v-icon>
                    </div>
                    <div class="flex items-center gap-[10px] lg:flex-col">
                        <div
                            class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-green"
                        >
                            <v-icon
                                icon="graph-leaf"
                                class="text-white"
                            ></v-icon>
                        </div>
                        <div class="text-body-medium-button">
                            2. Dodatni podatki
                        </div>
                    </div>
                    <v-icon
                        icon="arrow-right"
                        class="hidden text-gray lg:flex"
                    ></v-icon>
                    <div
                        class="mb-2 mt-2 flex w-[40px] justify-center lg:hidden"
                    >
                        <v-icon icon="arrow-down" class="text-gray"></v-icon>
                    </div>
                    <div class="flex items-center gap-[10px] lg:flex-col">
                        <div
                            class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-green"
                        >
                            <v-icon
                                icon="image-photo-add"
                                class="text-white"
                            ></v-icon>
                        </div>
                        <div class="text-body-medium-button">
                            3. Dodajte opis in slike
                        </div>
                    </div>
                    <v-icon
                        icon="arrow-right"
                        class="hidden text-gray lg:flex"
                    ></v-icon>
                    <div
                        class="mb-2 mt-2 flex w-[40px] justify-center lg:hidden"
                    >
                        <v-icon icon="arrow-down" class="text-gray"></v-icon>
                    </div>
                    <div class="flex items-center gap-[10px] lg:flex-col">
                        <div
                            class="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-green"
                        >
                            <v-icon
                                icon="house-check"
                                class="text-white"
                            ></v-icon>
                        </div>
                        <div class="text-body-medium-button">
                            4. Objavite oglas
                        </div>
                    </div>
                </figure>
                <hr class="mb-11 mt-28 hidden lg:visible" />
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="start-step-form"
                >
                    <v-csrf-token></v-csrf-token>
                    <figure>
                        <div
                            class="mb-4 flex w-full items-center justify-center"
                        >
                            <div class="text-body-regular text-black-40">
                                Izberite:
                            </div>
                        </div>
                        <div
                            class="grid grid-cols-2 grid-rows-1 gap-6 lg:flex lg:flex-wrap lg:justify-center lg:gap-4"
                        >
                            <div
                                name="prodaja"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.vermarktungsart
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="vermarktungsart"
                                    id="rent-or-sell-1"
                                    value="kauf"
                                    class="hidden"
                                    v-model="marketingMethod"
                                />

                                <label
                                    for="rent-or-sell-1"
                                    class="flex min-h-[171px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all"
                                >
                                    <img
                                        :src="$assetsUrl + '/images/sell.webp'"
                                        alt="Hiša"
                                        class="pointer-events-none mb-4 min-h-[80px] w-20 select-none transition-all"
                                    />

                                    <span
                                        class="pointer-events-none select-none"
                                        >Prodaja</span
                                    >
                                </label>
                            </div>
                            <div
                                name="oddaja"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.vermarktungsart
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="vermarktungsart"
                                    id="rent-or-sell-2"
                                    value="miete"
                                    class="hidden"
                                    v-model="marketingMethod"
                                />

                                <label
                                    for="rent-or-sell-2"
                                    class="flex min-h-[171px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all"
                                >
                                    <img
                                        :src="$assetsUrl + '/images/rent.webp'"
                                        alt="Stanovanje"
                                        class="pointer-events-none mb-4 min-h-[80px] w-20 select-none transition-all"
                                    />

                                    <span
                                        class="pointer-events-none select-none"
                                        >Oddaja</span
                                    >
                                </label>
                            </div>
                        </div>
                    </figure>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('start-step-form')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            marketingMethod: null,
        };
    },
    mounted() {
        this.marketingMethod = this.stepData.vermarktungsart;
    },
    methods: {
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
    },
    computed: {
        validated() {
            if (!this.marketingMethod) {
                return false;
            }

            return true;
        },
    },
};
</script>
